import React from "react";
import { ExerciseTypeContainer } from "./ExerciseTypeContainer";

type WatchSimpleVideoProps = {
  item: {
    id: number;
    name: string;
  };
};

export const WatchSimpleVideo: React.FC<WatchSimpleVideoProps> = ({ item }) => {
  return (
    <ExerciseTypeContainer
      item={item as never}
      title1={item.name}  
      exerciseNumber={item.id.toString()}
      hideVerifyButton={true}
    >
      Assista ao video simples
    </ExerciseTypeContainer>
  );
};
